/*********************
Close Rule
*********************/
import Rule from '../Rule';
import { ruleInputTypes, ruleTypes } from '../../../constants';
import {buildLogForRule} from '../../../utils/logUtils';

// NOTE: this rule currently doesn't apply to word level interventions,
// as we don't have the necessary features to make a word-level determination
export default class CloseRule extends Rule {
  constructor(logic) {
    super([],logic); // No required fields
    this.ruleType = ruleTypes.CLOSE;
  }

  // override the default run rule
  run(state) {
    // if this is a word level intervention return
    if(!state.endOfPhrase) {
      return {
        stateMeetsRuleCondition: true,
        decisionContext: {[(this.ruleType + '_true')]: ' close rule condition met by default due to word level intervention'},
        log: `PASSED: ${this.ruleType} qualified by default due to word level intervention`,
      }
    }

    // Determine whether rule meets close condition
    let meetsCloseCondition = false;
    state.closeErrors.forEach(err => {
      if(err.index == state.wordIndex) {
        meetsCloseCondition = true;
      }
    });

    // Allow config-specified logic to manipulate isClose (e.g. invert to isNotClose, if desired)
    meetsCloseCondition = this.logic(meetsCloseCondition);
    return {
      stateMeetsRuleCondition: meetsCloseCondition,
      decisionContext: {[(this.ruleType + '_'+meetsCloseCondition)]: 'error met specified close type condition = ' + meetsCloseCondition},
      log: buildLogForRule(this, state, meetsCloseCondition),
    }
  }
}